import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { useQueryParams } from "@shared/hooks";
import { Product } from "@modules/defaultProducts/types";
import { getProductsService } from "@modules/defaultProducts/services";
import { useQuery } from "@tanstack/react-query";

export function useProductsList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  
  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();
  

  const {
    data: rows = [],
    isLoading: loading,
    refetch,
  } = useQuery({
    queryKey: ["products", getQueryParams()],
    queryFn: () => getProductsService(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id!))
      : rows;
  }, [selectedRows, rows]);

  const tableProps = {
    page: 0,
    pageSize: 25,
    rowCount: rows.length,
  };

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    refetch,
    setSelectedRows,
    translate,
  };
}
